export const GET_DRAFTS = 'Get_Drafts';